<div [formGroup]="form">
    <div hamCheckbox bubbleEvents="true" formControlName="acceptPolicy" color="primary">
        {{ localizations.aumico_users_registration_read_and_agree | i18next }}
        <a
            [href]="termsAndConditionsUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="policy-link"
            (mousedown)="openLink($event, termsAndConditionsUrl)"
        >
            {{ localizations.aumico_users_registration_terms_and_conditions | i18next }}
        </a>
        {{ localizations.aumico_reports_accept_policy_dialog_first_paragraph_the | i18next }}
        <a
            [href]="agreementOnOrderDataProcessingUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="policy-link"
            (mousedown)="openLink($event, agreementOnOrderDataProcessingUrl)"
        >
            {{ localizations.aumico_users_registration_agreement_on_data_processing | i18next }}
        </a>
        {{ localizations.aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those | i18next }}
        <a
            [href]="pricesUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="policy-link"
            (mousedown)="openLink($event, pricesUrl)"
        >
            {{ localizations.aumico_users_registration_prices | i18next }}
        </a>
        {{ localizations.aumico_users_registration_text_between_links | i18next }}
        <a
            [href]="privacyPolicyUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="policy-link"
            (mousedown)="openLink($event, privacyPolicyUrl)"
        >
            {{ localizations.aumico_users_registration_privacy_policy | i18next }}
        </a>
        {{ localizations.aumico_users_registration_text_after_links | i18next }}
    </div>

    <div
        hamCheckbox
        formControlName="subscribeMarketing"
        color="primary"
        role="checkbox"
        [attr.aria-checked]="form.get('subscribeMarketing')?.value"
        tabindex="0"
    >
        {{ localizations.aumico_reports_registration_welcome_market_communication_subscription | i18next }}
    </div>
</div>

<div *ngIf="acceptPolicy?.errors?.['required']" class="policy-error">
    {{ localizations.aumico_reports_registration_welcome_privacy_policy_error | i18next }}
</div>
